import { useEffect, useState } from "react";
import { Button, Form, InputGroup } from "react-bootstrap";
import { X } from "react-feather";
import { useAsyncDebounce } from "react-table";

const GlobalFilter = ({
  manualGlobalFilter,
  preGlobalFilteredRows,
  globalFilter,
  setGlobalFilter,
  data,
  totalCount,
}) => {
  const count = manualGlobalFilter ? totalCount : preGlobalFilteredRows.length;
  const [value, setValue] = useState(globalFilter);

  const onChange = useAsyncDebounce((value) => {
    setGlobalFilter(value || undefined);
  }, 200);

  // Sets the input value to "" every time data is updated.
  useEffect(() => {
    if (!manualGlobalFilter) {
      setValue("");
    }
  }, [data, manualGlobalFilter]);

  return (
    <span>
      <InputGroup>
        <Form.Control
          placeholder={`Search ${count} records...`}
          value={value || ""}
          onChange={(e) => {
            setValue(e.target.value);
            onChange(e.target.value);
          }}
        />
        {value ? (
          <Button
            variant="outline-danger"
            onClick={() => {
              setValue(undefined);
              onChange(undefined);
            }}
          >
            <X size={16} />
          </Button>
        ) : null}
      </InputGroup>
    </span>
  );
};

export default GlobalFilter;
